import {
  FAIcon,
  IconStyle,
  useBreakpoint,
  Breakpoints,
  useTranslation,
  useMasterData,
} from '@nextgen-web-framework/all';
import { CheckoutLocationContainer, ShippingTypeEnums } from '@commerce-checkout-webcomponents/ui';
import { CheckoutProfileService } from '@commerce-checkout-webcomponents/sdk';
import { Config } from '@com.amway.commerce/webshop-configs-v1-prod/Schema';
import { CommonLocationProps } from '../types/propTypes';
import styles from './DesktopLocation.module.scss';

const DesktopLocation = ({
  shippingType,
  showLocation,
  setLocation,
  onDeliveryAddressConfirm,
  addressToDisplay,
  postalCodeToDisplay,
  disableLocationHeader,
}: CommonLocationProps) => {
  const viewPortType = useBreakpoint();

  const t = useTranslation();

  const isDesktop = viewPortType === Breakpoints.XL;
  const separator = shippingType === ShippingTypeEnums.DELIVERY ? ',' : ':';
  const webShopConfigs = useMasterData<Config>('WebshopConfigs') as Config;
  const address = CheckoutProfileService.getCheckoutProfile();
  const nickname = address?.fulfillmentType.serviceLevel?.deliveryAddress?.contactNickname;
  const shouldHidePostalCode = !!webShopConfigs?.contactNickName && !!nickname?.trim();
  return (
    <div className={styles['location-container']} data-testid="desktop-location-test-id">
      <div
        className={styles['location-selector']}
        onClick={() => setLocation(true)}
        onKeyDown={() => setLocation(true)}
        role="presentation"
        data-testid="location-selector-test-id"
      >
        {shippingType === ShippingTypeEnums.DELIVERY ? (
          <FAIcon iconName="truck" iconStyle={IconStyle.REGULAR} className={styles['location-selector-icon']} />
        ) : (
          <FAIcon iconName="location-dot" iconStyle={IconStyle.REGULAR} className={styles['location-selector-icon']} />
        )}
        {isDesktop ? (
          <span className={styles['delivery-text']}>
            {addressToDisplay ? (
              <div className={styles['delivery-text-container']}>
                <span className={styles['delivery-text-container-address']}>{addressToDisplay}</span>
                {!shouldHidePostalCode && postalCodeToDisplay ? (
                  <>
                    <span>{separator}</span>
                    <span className={styles['delivery-text-container-postalCode']}>{postalCodeToDisplay}</span>
                  </>
                ) : null}
              </div>
            ) : (
              t('web.location.selector')
            )}
          </span>
        ) : (
          ''
        )}
      </div>
      {showLocation && !disableLocationHeader && (
        <CheckoutLocationContainer setLocation={setLocation} onDeliveryAddressConfirm={onDeliveryAddressConfirm} />
      )}
    </div>
  );
};

export default DesktopLocation;
